import { render, staticRenderFns } from "./user_info.vue?vue&type=template&id=575c2f42&scoped=true"
import script from "./user_info.vue?vue&type=script&lang=js"
export * from "./user_info.vue?vue&type=script&lang=js"
import style0 from "./user_info.vue?vue&type=style&index=0&id=575c2f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575c2f42",
  null
  
)

export default component.exports